import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';

import TkForm from '@/../bower_components/teknisavuecomponents/components/TkForm.vue';


@Component({
  name: 'CardAnexoFoto',
  components: {
    TkForm,
  },
})
class CardAnexoFoto extends Vue {

  private get cardTitle(): string {
    return 'Cadastro de Biometria Facial';
  }

  @Prop({ default: null })
  private readonly fotoBase64 : string | null;

  @Emit('clickPhoto')
  private emitClickPhoto(value: boolean): boolean {
    return value;
  }

  @Emit('clearPhoto')
  private emitClearPhoto(value: boolean): boolean {
    return value;
  }

  private created() {

  }

  private closePopup() {

  }

  private async openTirarFoto() {
    this.emitClickPhoto(true);
  }

  private clearPhoto() {
    this.emitClearPhoto(true)
  }
}

export default CardAnexoFoto;